import BundleProduct from '../BundleProduct';
import { BadgeData } from '../../../Badge/types';
import { StyledApplovinBundle } from '../style';
import { BundleProps } from '../../types';
import { Box } from '@mui/material';
import { AplBundlePrice } from '../BundlePrice/AplBundlePrice';
import {
    EBadgePosition,
    EProductPriority,
    EProductType
} from '../../../Helper/enums';
import Badge from '../../../Badge/CornerBadge';

function Bundle({
    backgroundColor = { colorOne: '#000088' },
    backgroundSrc,
    price = {
        price: 100,
        currencySymbol: '$',
        isCents: true,
        symbolPosition: 'right',
        fractionalSeparator: '.',
        milSeparator: ',',
        spacing: false,
        currencyCode: 'usd'
    },
    productList = [
        {
            textFontColorHex: '#ffabff',
            images: {
                product:
                    'https://animal-kingdom-media.s3.amazonaws.com/asset-2.png?a=a'
            },
            quantity: 100,
            prefix: '',
            suffix: '',
            priority: EProductPriority.MAIN,
            quantityDisplay: '100',
            productType: EProductType.QUANTITY
        }
    ],
    bundleBorderColor,
    availability,
    playerAvailability,
    bundleButtonTextColor,
    fontFamily,
    badges = [],
    salePercentage = 0,
    bundleRef,
    borderRadius
}: BundleProps) {
    const availabilityText =
        availability?.remaining && availability?.total
            ? `${availability.remaining}/${availability.total}`
            : '';

    return (
        <StyledApplovinBundle
            bundleBorderColor={bundleBorderColor}
            fontFamily={"'Neuron', Arial, sans-serif"}
            backgroundColor={backgroundColor}
            textColor={bundleButtonTextColor}
            className="main-sub-bundle"
            ref={bundleRef}
            borderRadius={borderRadius}
            backgroundSrc={backgroundSrc}
        >
            <Box className="upper part">
                {productList.length > 0 ? (
                    <BundleProduct
                        productType={productList[0].productType}
                        images={productList[0].images}
                        quantity={productList[0].quantity}
                        prefix={productList[0].prefix}
                        suffix={productList[0].suffix}
                        salePercentage={salePercentage}
                        quantityDisplay={productList[0].quantityDisplay}
                        strokedSaleQuantity={productList[0].strokedSaleQuantity}
                    />
                ) : null}
            </Box>
            <Box className="lower part">
                <AplBundlePrice price={price}></AplBundlePrice>
            </Box>
            {Array.isArray(badges) &&
                badges?.map((badge: BadgeData, i: number) => {
                    if (
                        badge.position === EBadgePosition.RIGHT &&
                        salePercentage
                    )
                        return;
                    return <Badge {...badge} key={i} />;
                })}
            {availabilityText && (
                <span className="availability quantity">
                    {availabilityText}
                </span>
            )}
        </StyledApplovinBundle>
    );
}

export default Bundle;
